module.exports = __webpack_public_path__ + "img/hide-mini.0509153e.png";